// extracted by mini-css-extract-plugin
export default {"container":"Unauthorized_container__ebnyi","heading":"Unauthorized_heading__nTHlI","link":"Unauthorized_link__GdU+0","goto":"Unauthorized_goto__Lqrqy"};